import { Box, BoxProps, ComponentWithAs, forwardRef } from '@chakra-ui/react';
import React from 'react';
import Counter from '../atom/Counter';
import useRollCount from '../../../hooks/firebaseHooks';

const RecommendationCount: ComponentWithAs<'div', BoxProps> = forwardRef<BoxProps, 'div'>((props, ref) => {
  const [rollCount, error] = useRollCount();
  if (error) {
    console.log(error);
  }
  return (
    <Box ref={ref} {...props}>
      <Counter count={rollCount} />
    </Box>
  );
});

export default RecommendationCount;
